// Issue #1206: chip rendered on file cards and the file detail view when
// pipeline processing failed, with a tooltip carrying the recorded reason.
// Mirrors MissingCalibrationChip (#696) so the two read alike.

import React from 'react';
import { Chip, Tooltip, Box } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { processingFailureReason } from '../../utils/processingFailureReason';

/**
 * @param {{ file: object, size?: 'small'|'medium' }} props
 *   `file` is a userfile shape with processing_status / processing_error /
 *   processing_error_class set by the userFilesRoutes endpoints.
 *   Renders nothing unless processing_status === 'failed'.
 */
const ProcessingFailureChip = ({ file, size = 'small' }) => {
    const chip = processingFailureReason(file);
    if (!chip) return null;

    const tooltipContent = (
        <Box sx={{ whiteSpace: 'pre-line' }}>
            {chip.tooltipLines.join('\n')}
        </Box>
    );

    return (
        <Tooltip title={tooltipContent} placement="top">
            <Chip
                label={chip.label}
                size={size}
                color={chip.color}
                icon={<ErrorOutlineIcon />}
                variant="outlined"
            />
        </Tooltip>
    );
};

export default ProcessingFailureChip;
